import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';
import FormHelperText from '@material-ui/core/FormHelperText';
import MaterialSelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { getHelpOrError, hasError } from './_common';

const Select = ({
  label,
  name,
  errors,
  value,
  options,
  help,
  onChange,
  onBlur,
  required,
  disabled,
  multiple,
  style,
  ...rest
}) => {
  return (
    <FormControl
      fullWidth={rest.fullWidth !== false}
      margin="none"
      style={{ marginTop: '8px', ...style }}
      required={required}
    >
      <InputLabel>{label}</InputLabel>
      <MaterialSelect
        margin="dense"
        name={name}
        value={value || ''}
        fullWidth
        error={hasError(errors, name)}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        multiple={multiple}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
        renderValue={
          multiple
            ? (selected) => {
                const items = options.filter((o) => selected.includes(o.value));

                return (
                  <>
                    {items.map((item, i) => (
                      <Chip
                        key={i}
                        label={item.label}
                        color="primary"
                        style={{ marginRight: '10px' }}
                      />
                    ))}
                  </>
                );
              }
            : null
        }
        {...rest}
      >
        {options.map((o, i) => (
          <MenuItem disabled={o.disabled} key={i} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </MaterialSelect>
      <FormHelperText error={hasError(errors, name)}>
        <span>{getHelpOrError(help, errors, name)}</span>
      </FormHelperText>
    </FormControl>
  );
};

Select.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  errors: PropTypes.shape({}).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      disabled: PropTypes.bool,
    }),
  ),
  onBlur: PropTypes.func,
  help: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  style: PropTypes.shape({}),
};

export default Select;
